// extracted by mini-css-extract-plugin
module.exports = {"nav":"Nav_nav__2q5jM","mainLinks":"Nav_mainLinks__1Lg9i","active":"Nav_active__1PD6c","navLink":"Nav_navLink__1OTwo","avatar":"Nav_avatar__16du9"};